import {
postersUnescapeSpacesAndApostrophes,
        } from "./posters.js";
import {
posterAppendAuthor,
        posterRender
        } from "./poster.js";
import { IfQuickReloadFlushEverything } from "./cache.js";
import {
pageFetchPosters,
        pageGetNextPageHref,
        pageGetPostersNumber
        } from "./page.js";
import { controlStartUp } from "./control.js";

// function mainSetGetLabelCookie(label, labelName)
// {
//    if (label === null)
//    {
//        label = browserGetCookie(labelName);
//    } else
//    {
//        if (label !== "")
//        {
//            label = postersUnescapeSpacesAndApostrophes(label);
//        }
//        browserSetCookie(labelName, label, 1);
//    }
//    return(label);
// }

function mainGetString(param, label = null, unescape = true) {
    if (label) {
        param = label;
    }

    if (param === null) {
        return "";
    } else {
        if (unescape === true) {
            return postersUnescapeSpacesAndApostrophes(param);
        } else {
            return param;
        }
}
}

function mainStartUp(label = null, town = null, region = null) {
    let params = new URL(document.location).searchParams;
    let mainIndex = params.get("index") || 0;
    let mainLabel = mainGetString(params.get("label"), label);
    let mainTown = mainGetString(params.get("town"), town);
    let mainRegion = mainGetString(params.get("region"), region);
    let mainFlush = mainGetString(params.get("flush"));
    let mainCursor = mainGetString(params.get("cursor"), null, false);

    // check that there is cursor cookie for the index
    //    if (posterIsThereCursorForTheIndex(mainIndex) === false)
    //    {
    //        window.location.replace("/");
    //        return;
    //    }

    // set region, erases town cookie
    if (mainRegion !== "" && mainRegion !== null && mainTown === null) {
        mainTown = "";
    }
    // set town erases region
    if (mainTown !== "" && mainTown !== null && mainRegion === null) {
        mainRegion = "";
    }

    // it is there a quick reload is flushed everything ---------------------
    IfQuickReloadFlushEverything();

    // page posters ----------------------------------------------------
    let mainPostersWrapper = document.getElementById("mainPostersWrapper");
    if (mainPostersWrapper.dataset.postersLoaded === "false") {
        //
        document.getElementById("mainLoader").style.display = "inline-block";

        //
        pageFetchPosters(
                mainPostersWrapper,
                mainRegion,
                mainTown,
                mainLabel,
                mainIndex,
                mainCursor
                )
                .then((isThereMorePosters) => {
                    //
                    if (pageGetPostersNumber() === 0) {
                        let element = document.createElement("div");
                        element.setAttribute("id", "mainNoPostersMessage");
                        let text;
                        text = "No hi ha cartells";

                        if (mainLabel !== "") {
                            text += " amb l'etiqueta <b class='nowrap'>" + mainLabel + "</b>,";
                        }
                        if (mainTown !== "") {
                            text += " a <b class='nowrap'>" + mainTown + "</b>,";
                        }
                        if (mainRegion !== "") {
                            text += " a <b class='nowrap'>" + mainRegion + "</b>,";
                        }
                        text +=
                                " publica el teu cartell a " +
                                "<a class='nowrap' href='//editor.elmolideponent.com'> editor.elmolideponent.com</a>";
                        element.innerHTML = text;
                        mainPostersWrapper.appendChild(element);
                    }
                    // next page button --------------------------------------------
                    if (isThereMorePosters === true) {
                        document.getElementById("mainNextPageButtonWrapper").style.display =
                                "block";
                        document
                                .getElementById("mainNextPageButton")
                                .setAttribute("href", pageGetNextPageHref());
                    } else {
                        if (mainIndex !== 0) {
                            document.getElementById("mainNextPageButtonWrapper").style.display =
                                    "block";
                            document.getElementById("mainNextPageButton").textContent =
                                    "Pricipal";
                            document
                                    .getElementById("mainNextPageButton")
                                    .setAttribute("href", "/");
                        } else if (mainLabel !== "" || mainTown !== "" || mainRegion !== "") {
                            // document.getElementById('mainNextPageButtonWrapper').style.display = 'block';
                            // document.getElementById('mainNextPageButton').textContent = "Pricipal";
                            // document.getElementById('mainNextPageButton').setAttribute('href', "/?label=&town=&region=");
                            document.getElementById("mainNextPageButtonWrapper").style.display =
                                    "none";
                            _mainOthersPosters();
                        } else {
                            document.getElementById("mainNextPageButtonWrapper").style.display =
                                    "none";
                        }
                    }
                })
                .catch((err) => {
                    console.log(err.stack);
                    window.alert("Alguna cosa ha anat malament: " + err);
                })
                .finally(() => {
                    document.getElementById("mainLoader").style.display = "none";
                });
    } else {
        // crawl version ------------------------------------------------------
        // rendering posters
        posterRender();

        // download publishers
        let auxPosters = mainPostersWrapper.getElementsByClassName("posterWrapper");
        [].forEach.call(auxPosters, (poster) => {
            posterAppendAuthor(poster);
        });
    }

// moved to the server
//    if (mainLabel !== "" || mainTown !== "" || mainRegion !== "") {
//        document.getElementById("mainFilters").style = "display: block;";
//}
}

function _mainOthersPosters() {
    let mainOtherPosters = document.getElementById("mainOtherPosters");
    if (mainOtherPosters !== null) {
        mainOtherPosters.style = "display: block;";

        let mainOtherPostersWrapper = document.getElementById(
                "mainOtherPostersWrapper"
                );

        //console.log("other ");

        controlStartUp("mainOtherSentinel");

        pageFetchPosters(mainOtherPostersWrapper, "", "", "", 0).then(
                (isThereMorePosters) => {
            if (isThereMorePosters === true) {
                document.getElementById(
                        "mainOtherNextPageButtonWrapper"
                        ).style.display = "block";
                document
                        .getElementById("mainOtherNextPageButton")
                        .setAttribute("href", pageGetNextPageHref());
            } else {
                document.getElementById(
                        "mainOtherNextPageButtonWrapper"
                        ).style.display = "none";
            }
        }
        );
    }
}

export { mainStartUp };
